import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import Icon from '../../assets/logo.svg'
import styles from './styles.module.scss'

export const Logo = ({ miniMobile }) => (
  <Fragment>
    <Link
      title="How much to make an app logo"
      className={`${styles.logo} ${miniMobile ? styles.miniMobile : ''}`}
      to="/"
    >
      <Icon />
      <span>How Much To Make An APP</span>
    </Link>
  </Fragment>
)
